import differenceWith from "ramda/src/differenceWith";

export const areAllSelected = ({ items, selected }) => {
  if (items.length === 0) {
    return false;
  }

  const diff = differenceWith((a, b) => a.id === b.id, items, selected);

  return diff.length === 0;
};
